// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Linkedin = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M20.375 1.577v16.846a1.453 1.453 0 0 1-1.452 1.452H2.077a1.452 1.452 0 0 1-1.452-1.452V1.577A1.452 1.452 0 0 1 2.077.125h16.846a1.452 1.452 0 0 1 1.452 1.452Zm-13.941 6.1H3.529v9.294h2.905V7.676Zm.261-3.195a1.673 1.673 0 0 0-1.661-1.685h-.052a1.685 1.685 0 0 0 0 3.37 1.673 1.673 0 0 0 1.713-1.633v-.052Zm10.776 6.842c0-2.794-1.778-3.88-3.544-3.88a3.31 3.31 0 0 0-2.94 1.499h-.08V7.676h-2.73v9.295h2.904v-4.944a1.929 1.929 0 0 1 1.742-2.08h.11c.925 0 1.61.582 1.61 2.045v4.979h2.904l.024-5.647Z"
			fill="#2867B2"
		/>
	</svg>
);
export default Linkedin;
